import React from "react"
import Navbar from "../../../../Common/Components/Navbar"
import Footer from "../../../../Common/Components/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import EnquiryTableComp from "./Component/EnquiryTableComp"

const Enquiry =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EnquiryTableComp />
        </div>
        <Footer />
        </>
    )
}

export default Enquiry